import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f766a0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "abnormal-goods-tip"
}
const _hoisted_2 = {
  key: 0,
  class: "abnormal-tip"
}
const _hoisted_3 = {
  class: "primary",
  style: {"padding":"10px 0","color":"#333333","max-width":"200px"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-tishi1" }, null, -1))
const _hoisted_5 = { class: "abnormal-tip-text" }
const _hoisted_6 = { class: "tip-text" }
const _hoisted_7 = { class: "btn-link-slot flex-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-sousuo" }, null, -1))
const _hoisted_9 = { class: "tip-jump-same" }
const _hoisted_10 = {
  key: 1,
  class: "slow-tip abnormal-tip"
}
const _hoisted_11 = {
  class: "primary",
  style: {"padding":"10px 0","color":"#333333","max-width":"200px"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-tishi1" }, null, -1))
const _hoisted_13 = { class: "tip-text" }

import { t } from '@/plugins/i18n'
import { searchGoodsDefectiveApi } from '@/apis/goods'
import { watch, ref } from 'vue'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  props: ['productCode', 'product'],
  setup(__props) {

const props = __props
const store = useStore()

const showStatus = ref(0)
watch(() => props.productCode, (newValue: string) => {
  showStatus.value = 0
  if (!newValue) return
  searchGoodsDefectiveApi({
    productCodeList: newValue
  }).then((res: any) => {
    console.log(res)
    if (res.data && res.data.length > 0) {
      showStatus.value = res.data[0]?.showStatus || 0
    } else {
      showStatus.value = 0
    }
  })
})

const loading = ref(false)
const getFileFromUrl = (url: any, fileName: any) => {
  return new Promise((resolve, reject) => {
    var blob = null
    var xhr = new XMLHttpRequest()
    xhr.open('GET', url)
    xhr.setRequestHeader('Accept', 'image/png')
    xhr.responseType = 'blob'
    // 加载时处理
    xhr.onload = () => {
      // 获取返回结果
      blob = xhr.response
      const file = new File([blob], fileName, { type: 'image/png' })
      // 返回结果
      resolve(file)
    }
    xhr.onerror = (e) => {
      reject(e)
    }
    // 发送
    xhr.send()
  })
}
const search = () => {
  if (loading.value) return
  loading.value = true
  getFileFromUrl(props.product.productMainImg, 'img')
    .then((response: any) => {
      store.dispatch('extension/uploadImg', [response])
    }).catch(() => {
      loading.value = false
    }).finally(() => {
      loading.value = false
    })
}

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!

  return (showStatus.value > 0 && props.productCode)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (showStatus.value < 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_el_tooltip, {
                placement: "bottom",
                effect: "light",
                "popper-class": "tool-tip-no-border",
                offset: 10
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('※商品不良包含：次品、到错货、多件/少件情况。')), 1)
                ]),
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('该商品近30天不良率超过X%，请谨慎选择。').replace('X', showStatus.value === 1 ? '40' : '50')), 1),
                _createVNode(_component_el_button, {
                  link: "",
                  class: "btn-link",
                  loading: loading.value,
                  onClick: search
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)('去找同款')), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_el_tooltip, {
                placement: "bottom",
                effect: "light",
                "popper-class": "tool-tip-no-border",
                offset: 10
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('※回货时长超过15天。')), 1)
                ]),
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)('该商品近30天回货速度慢，请谨慎选择。')), 1)
            ]))
      ]))
    : _createCommentVNode("", true)
}
}

})